import { TemplatePage } from './types';

const technologyPage: TemplatePage = {
  header: {
    color: '#FFF079',
    icon: 'images/video-templates/technology-computers.jpg',
    title: 'Technology Video Templates Collection',
    title_meta: '50+ Free Technology Video Templates ',
    description_meta:
      'Browse Wave.video’s collection of 50+ high-quality technology video templates that are easy to edit even for non-designers.',
    description:
      'Browse the collection of 50+ high-quality technology video templates that are easy-to-edit even for non-designers. ' +
      'Create your own attention-grabbing tech video quick and hassle-free!'
  },
  footer: {
    category: 'Technology',
    description:
      'Wave.video’s extensive collection of professional-looking technology video templates helps to make top-notch videos ' +
      'for any purpose. All the templates are easy and free to customize to suit your brand and message.'
  },
  content: [
    {
      type: 'templates',
      title: 'technology and computers',
      search: { category: '/Industries/Technology' }
    },
    {
      type: 'stocks',
      title: 'technology and computers',
      search: { name: 'technology' }
    },
    { type: 'calendar' }
  ]
};

export default technologyPage;
